import { render, staticRenderFns } from "./ExamRule.html?vue&type=template&id=74f3a2f2&scoped=true&external"
import script from "./ExamRule.vue?vue&type=script&lang=js"
export * from "./ExamRule.vue?vue&type=script&lang=js"
import style0 from "./ExamRule.css?vue&type=style&index=0&id=74f3a2f2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f3a2f2",
  null
  
)

export default component.exports